/* ZAKIO Buy Now — native cart AJAX, then Shopify standard checkout (no forced Shop account).
 * Keeps the store's selected variant, quantity, and line-item properties.
 * Existing basket items remain in checkout; Shopify validates stock and quantity.
 */
(() => {
  if (window.__zakioBuyNowBound) return;
  window.__zakioBuyNowBound = true;
  document.addEventListener('click', async (event) => {
    const button = event.target.closest?.('[data-zk-buy-now]');
    if (!button || button.disabled || button.dataset.busy === 'true') return;
    const form = button.closest('form');
    if (!form || !form.reportValidity()) return;

    // Respect the variant inventory state already resolved by the Shopify theme.
    const addButton = form.querySelector('.add-to-cart-button');
    if (addButton?.disabled) return;
    const selectedId = form.querySelector('input[name="id"]')?.value;
    if (!selectedId || !/^\d+$/.test(selectedId)) return;

    const error = button.parentElement.querySelector('[data-zk-buy-now-error]');
    if (error) { error.hidden = true; error.textContent = ''; }
    const originalText = button.innerHTML;
    const data = new FormData(form);
    data.set('id', selectedId);
    if (!data.get('quantity')) {
      const qty = form.querySelector('input[name="quantity"]')?.value;
      data.set('quantity', qty || '1');
    }
    button.disabled = true;
    button.dataset.busy = 'true';
    button.setAttribute('aria-busy', 'true');
    button.textContent = 'Opening secure checkout…';
    try {
      const url = button.dataset.cartAddUrl || '/cart/add';
      // Shopify accepts form payload at /cart/add.js and validates stock.
      const res = await fetch(url.replace(/\/cart\/add\/?$/, '/cart/add.js'), {
        method: 'POST',
        body: data,
        credentials: 'same-origin',
        headers: { Accept: 'application/json' },
      });
      if (!res.ok) {
        let body;
        try { body = await res.json(); } catch (_) {}
        throw new Error(body?.description || body?.message || 'This item could not be added. Please try again.');
      }
      window.location.assign(button.dataset.checkoutUrl || '/checkout');
    } catch (err) {
      if (error) {
        error.textContent = err?.message || 'We could not open checkout. Please try again.';
        error.hidden = false;
      }
      button.disabled = false;
      button.dataset.busy = 'false';
      button.removeAttribute('aria-busy');
      button.innerHTML = originalText;
    }
  });
})();
